import { z } from 'zod'
import { auditFieldsSchema, decimalSchema, uuidSchema } from './common.ts'
import { unitSchema } from './units.ts'

export const grossUnitPriceSchema = z
  .string()
  .regex(/^\d+(\.\d{1,2})?$/, 'Вкажіть ціну у форматі 1250 або 1250.50')

export const positiveQuantitySchema = z
  .string()
  .regex(/^\d+(\.\d+)?$/, 'Вкажіть кількість числом')
  .refine((value) => {
    const [whole, fraction = ''] = value.split('.')
    return whole !== undefined && `${whole}${fraction}`.replace(/^0+/, '').length > 0
  }, 'Кількість має бути більшою за нуль')

export const discountPercentSchema = z
  .string()
  .regex(/^\d+(\.\d{1,2})?$/, 'Вкажіть знижку у форматі 10 або 10.50')
  .refine((value) => {
    const [whole, fraction = ''] = value.split('.')
    const percentage = BigInt(whole ?? '0')
    return percentage < 100n || (percentage === 100n && /^0*$/.test(fraction))
  }, 'Знижка має бути від 0 до 100')

export const dealLineItemInputSchema = z.object({
  catalogItemId: uuidSchema.nullable().optional(),
  description: z.string().trim().min(1).max(500),
  quantity: positiveQuantitySchema,
  unit: unitSchema,
  unitPrice: grossUnitPriceSchema,
  discountPercent: discountPercentSchema.default('0'),
})

export type DealLineItemInput = z.infer<typeof dealLineItemInputSchema>

export const replaceDealLineItemsInputSchema = z.object({
  lineItems: z.array(dealLineItemInputSchema).max(200),
})

export type ReplaceDealLineItemsInput = z.infer<typeof replaceDealLineItemsInputSchema>

export const dealLineItemSchema = z
  .object({
    id: uuidSchema,
    dealId: uuidSchema,
    catalogItemId: uuidSchema.nullable(),
    position: decimalSchema,
    description: z.string(),
    quantity: decimalSchema,
    unit: unitSchema,
    unitPrice: grossUnitPriceSchema,
    discountPercent: decimalSchema,
    netAmount: decimalSchema,
    vatAmount: decimalSchema,
    totalAmount: decimalSchema,
  })
  .extend(auditFieldsSchema.shape)

export type DealLineItem = z.infer<typeof dealLineItemSchema>
